var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentAddTransparentSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m534 839-7 1H194c-24 0-46-22-46-47V136c0-24 22-46 46-46h304c5 0 10 2 15 4v177l1 8 1 3 1 2c5 12 15 17 27 19h168l5-1c5 1 6 4 6 9l-1 209a2615 2615 0 0 1-2 52l-19-1-1 1h-3l-10 1h-2c-6 0-12 0-18 4h-1l-3 1-8 2-2 1a2569 2569 0 0 0-21 8h-1a181 181 0 0 0-47 32h-1v1h-1l-1 1c1 0 1 0 0 0l-2 1-5 5-1 1-6 7-1 2h-1l-1 2h-1v1h-1l-1 1c-12 14-21 30-27 47l-7 20a1004 1004 0 0 0-7 38v30l1 8 7 31 1 4 1 3 1 3 1 4v2l1 2 2 4m-84-315v-1h-2v-1l-3-2H265l-4 2h-2c-9 5-13 14-8 22l10 9h181c3 0 5-2 8-3h1c3 0 4-2 4-5h1c3-4 4-8 1-13l-6-7-1-1m4-176c4-5 5-11 1-17l-11-8h-13l-2-1H263l-5 2c-5 3-8 7-9 13 0 9 4 14 12 18l5 1h175l4-1c4-1 8-1 8-7h1m-184 73c-4-2-7-2-11 1-6 4-11 10-10 17s4 12 11 13l1 1 5 2h244l4-1c4-1 9-1 10-7 4-3 5-7 2-12-1-6-4-11-11-13l-2-1v-1h-37l-4 2h-13a7438 7438 0 0 1-158-1l-1-1-2 2-28-1m93 208-10-11h-88l-5 1c-11 5-13 15-9 22 2 4 6 6 9 10l7 1h79c5 0 11-1 15-6s5-13 2-17Z",
    "data-index": 1,
    style: {
      opacity: 1,
      fill: "#e9e9e9",
      paintOrder: "stroke",
      stroke: "#c2c2c2",
      strokeWidth: 18,
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#729D84",
    d: "M586 617a172 172 0 0 1 45-28l17-5 6-4a517 517 0 0 1 13-3l18-3h14c14-2 27 0 41 3l23 4 29 12 9 5 6 3 3 2 5 3 2 1 3 2s-1 0 0 0l2 1h-1l3 2v1l4 2v1l1 1 2 1 1 1 3 3 1 1 1 1 9 8v1h1v1h1v1h1v1h1v1l3 4 1 1 1 1 2 2 1 2 4 3 20 35a175 175 0 0 1 14 64v1l-1 23v14a487 487 0 0 1-12 45h-1l-1 3-4 10c-18 35-43 62-77 81l-19 9-2 1-27 9h-1l-1 1-18 2-3-1c-9 2-19 2-28 1h-7l-15-1-28-6-7-2-15-6-3-1-5-2s1 0 0 0l-2-1-1-1-6-3-2-1v-1l-3-1v-1h-1v-1h-2v-1l-1-1h-1l-2-1-2-2-3-2h-1l-17-15-23-25-12-20-1-1h1l-9-21-3-4-1-3v-1l-1-2v-1l-1-3-7-31-1-9v-30l1-8 6-29 7-20a159 159 0 0 1 29-48l1-1 2-2v-1l1-2 6-6 1-1 5-5 3-1 1-1 1-1 2-2v-1l1-1m233 125v-1h-1v-1h-2v-1c-4-2-8-4-12-4h-63c-5 0-6-2-6-7v-61c0-5 1-11-5-15l-2-1-4-4c-8-4-15-3-23-2l-1 1-2-1-5 2-2 1-1 1-1 2-2 1-1 1-1 1v2h-1v2h-1l-1 8-1 49v13c1 6-1 6-6 6h-62c-4 0-8 0-10 5h-1l-3 2h-1l-1 1s1 0 0 0v1h-1c-3 2-5 4-3 9v14c0 11 4 16 14 21l6 1 69 1v68c0 4 2 7 3 11l1 1v1l1 1 1 1v1l4 1v1l4 1 12 2c10-1 20-2 25-14v-5l1-71h71l6-2h3l3-3 4-3 1-1v-2h1l1-2 1-20c0-3-2-5-3-8v-1l-1-1v-1l-1-1v-1h-1Z",
    "data-index": 2,
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0D0C9",
    d: "M543 303c-12-2-22-7-27-19l-1-2s0 0 0 0l-1-3V102l2-5h1l1 1s-1 0 0 0l1 1s-1 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1 33 34 2 2s-1 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l2 1 4 4 1 3s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1h1l1 1s-1 0 0 0l1 1s-1 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1v1h1v1h1v1h1v1h1v1l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1h1l1 1s-1 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1v1h1v1h1v1h1v1h1v1l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1h1l1 1s-1 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1v1h1v1h1v1l4 4s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l4 3s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1v1h1v1h1v1h1v1h1v1l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1 1 1 1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1h1l1 1 26 26 1 2v1h1v1h1v1l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1h1l1 1s-1 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1s0 0 0 0l1 1v1h1v1h1v1h1v1h1v1l2 2 1 1 1 2s0 0 0 0l1 1s0 0 0 0c0 5-3 4-5 4H549l-6 1h0Z",
    "data-index": 3,
    style: {
      opacity: 1,
      strokeWidth: 18,
      stroke: "#a0d0c9",
      strokeLinejoin: "round",
      strokeLinecap: "round"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5F9275",
    d: "m651 941 28 6 15 1h7c9 1 19 1 28-1l3 1-28 3c-18 0-36-3-53-9v-1Z",
    "data-index": 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "m516 97-2 5v176l-1-7V94l3 3Z",
    "data-index": 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "m543 303 6-1h160c2 0 5 1 5-4l1 4-4 1H543Z",
    "data-index": 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "m762 580-22-3c-14-3-27-5-41-3h-14l2-1a923 923 0 0 0 12-1h22l41 8Z",
    "data-index": 7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M792 593Z",
    "data-index": 8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M895 787v-14l1-23v-1h1l-2 38Z",
    "data-index": 9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M752 945Z",
    "data-index": 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "m530 827 3 4 9 21-8-13-2-5-1-1v-2l-1-4Z",
    "data-index": 11
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M651 941v1l-22-8 15 5 7 2Z",
    "data-index": 12
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M883 832Z",
    "data-index": 13
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M604 920h2-2Z",
    "data-index": 34
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M601 918h1-1Z",
    "data-index": 36
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M882 834v-2 2Z",
    "data-index": 40
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M831 617h-2 2Z",
    "data-index": 42
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M606 187h-1 1Z",
    "data-index": 48
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M610 191h-1 1Z",
    "data-index": 49
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M609 190h-1 1Z",
    "data-index": 50
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M608 189h-1 1Z",
    "data-index": 51
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M607 188h-1 1Z",
    "data-index": 52
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M611 192h-1 1Z",
    "data-index": 53
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M855 642h-1 1Z",
    "data-index": 60
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M619 201v-1 1Z",
    "data-index": 64
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M614 195h-1 1Z",
    "data-index": 71
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M518 99v-1 1Z",
    "data-index": 72
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M613 194h-1 1Z",
    "data-index": 73
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M612 193h-1 1Z",
    "data-index": 74
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M517 98v-1 1Z",
    "data-index": 75
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M578 160v-1 1Z",
    "data-index": 76
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M603 919h1-1Z",
    "data-index": 80
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M606 921h1-1Z",
    "data-index": 82
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M594 913h1-1Z",
    "data-index": 85
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M574 155h-1 1Z",
    "data-index": 90
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M573 154h-1 1Z",
    "data-index": 91
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M572 153h-1 1Z",
    "data-index": 93
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M854 641h-1 1Z",
    "data-index": 94
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M594 175h-1 1Z",
    "data-index": 97
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M593 174h-1 1Z",
    "data-index": 98
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M592 173h-1 1Z",
    "data-index": 99
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M591 172h-1 1Z",
    "data-index": 100
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M598 180v-1 1Z",
    "data-index": 101
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M590 171h-1 1Z",
    "data-index": 103
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M589 170h-1 1Z",
    "data-index": 104
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M588 169h-1 1Z",
    "data-index": 105
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M587 168h-1 1Z",
    "data-index": 106
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M586 167h-1 1Z",
    "data-index": 107
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M689 271h-1 1Z",
    "data-index": 108
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M691 273h-1 1Z",
    "data-index": 111
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M571 152h-1 1Z",
    "data-index": 113
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M690 272h-1 1Z",
    "data-index": 114
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M692 274h-1 1Z",
    "data-index": 117
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M688 270h-1 1Z",
    "data-index": 118
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M653 234h-1 1Z",
    "data-index": 124
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M570 151h-1 1Z",
    "data-index": 125
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M707 289h-1 1Z",
    "data-index": 127
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M708 290h-1 1Z",
    "data-index": 128
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M709 291h-1 1Z",
    "data-index": 129
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M652 233h-1 1Z",
    "data-index": 134
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M695 277h-1 1Z",
    "data-index": 140
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M694 276h-1 1Z",
    "data-index": 141
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M693 275h-1 1Z",
    "data-index": 142
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M836 622h-1 1Z",
    "data-index": 144
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M633 214h-1 1Z",
    "data-index": 145
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M632 213h-1 1Z",
    "data-index": 147
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M634 215h-1 1Z",
    "data-index": 149
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M848 634h-1 1Z",
    "data-index": 150
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M849 635h-1 1Z",
    "data-index": 151
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M850 636h-1 1Z",
    "data-index": 152
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M627 208h-1 1Z",
    "data-index": 153
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M651 232h-1 1Z",
    "data-index": 158
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M650 231h-1 1Z",
    "data-index": 159
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M649 230h-1 1Z",
    "data-index": 160
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M648 229h-1 1Z",
    "data-index": 161
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C8BF",
    d: "M647 228h-1 1Z",
    "data-index": 162
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M829 616h-1 1Z",
    "data-index": 168
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#bab1b0",
    d: "M260 452c-7-1-10-6-11-13s4-13 11-17h3l4 1h244l4-1c7 2 10 7 12 14l-3 11h-1l-8 5-4-1H264l-4 1Z",
    "data-index": 173,
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bab1b0",
    d: "M430 323h15l10 9c2 6 1 11-2 16-5 5-10 7-16 7H281l-20-1c-8-3-12-8-12-17 1-6 4-10 10-14h171Z",
    "data-index": 174,
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bab1b0",
    d: "m451 525 6 8-2 12-5 5-10 2H261l-10-8c-5-8-1-17 9-22l5 1h183l2 1 1 1Z",
    "data-index": 175,
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bab1b0",
    d: "m354 619 9 10c2 11-5 21-14 21l-3-1h-79l-4 1h-3c-3-3-7-5-9-9-4-7-2-17 10-22h93Z",
    "data-index": 176,
    style: {
      opacity: 1
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFD",
    d: "m515 452 8-5c0 6-5 6-9 7l-4 1a324554 324554 0 0 1-249-2h243l11-1Z",
    "data-index": 177
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6AEAB",
    d: "M448 523a45400 45400 0 0 1-6-2h4l2 2Z",
    "data-index": 178
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6AEAB",
    d: "m515 422-4 1a340845 340845 0 0 1-241-1h31a6873 6873 0 0 0 28 0h144l40-1 2 1Z",
    "data-index": 179
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6AEAB",
    d: "m515 452-11 1H261l-1-1 4-1a376849 376849 0 0 1 251 1Z",
    "data-index": 180
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFC",
    d: "M260 650h89c9 0 16-10 14-20 3 3 2 11-2 16s-10 6-15 6h-79l-7-2Z",
    "data-index": 181,
    style: {
      opacity: 1
    }
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFC",
    d: "M261 355h176c6 0 11-2 16-7 0 6-4 6-8 7l-4 1a216923 216923 0 0 1-180-1Z",
    "data-index": 182
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFD",
    d: "m261 553 179-1 10-2c-3 1-5 3-8 3H261Z",
    "data-index": 183
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFC",
    d: "M446 521H261l4-1a93911 93911 0 0 1 181 1Z",
    "data-index": 184
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFD",
    d: "M430 323H259l4-1a117004 117004 0 0 1 167 1Z",
    "data-index": 185
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFD",
    d: "m353 618-92 1 4-1a26388 26388 0 0 1 88 0Z",
    "data-index": 186
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFC",
    d: "M513 421a1539 1539 0 0 1-37-1h37v1Z",
    "data-index": 187
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M526 710Z",
    "data-index": 188
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "m654 580-6 4a303 303 0 0 1 6-4Z",
    "data-index": 189
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFD",
    d: "m684 573 1 1-18 3c5-4 11-4 17-4Z",
    "data-index": 190
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#377750",
    d: "M519 748Z",
    "data-index": 191
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFC",
    d: "M454 348c2-5 3-10 1-16 4 5 3 11-1 16Z",
    "data-index": 192
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFD",
    d: "M719 572h-19v-1l19 1Z",
    "data-index": 193
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFD",
    d: "m524 447 3-11c2 4 1 8-3 11Z",
    "data-index": 194
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFC",
    d: "m270 421-7 1h-3c3-3 6-3 10-1Z",
    "data-index": 195
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFD",
    d: "m456 545 1-12c3 4 2 8-1 12Z",
    "data-index": 196
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6AEAB",
    d: "M444 323Z",
    "data-index": 197
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFD",
    d: "m450 550 5-5c0 3-1 5-5 5Z",
    "data-index": 198
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFC",
    d: "m329 421-6 1c2-4 4-2 6-1Z",
    "data-index": 199
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFD",
    d: "M665 577h-2 2Z",
    "data-index": 201
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFC",
    d: "M301 422h-2l1-2 1 2Z",
    "data-index": 202
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M561 642v1-1Z",
    "data-index": 211
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFD",
    d: "M531 831v1-1Z",
    "data-index": 216
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M582 621v1-1Z",
    "data-index": 218
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M581 622v1-1Z",
    "data-index": 219
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M562 641v1-1Z",
    "data-index": 221
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFC",
    d: "M733 788v77c-5 11-15 12-25 13l-13-2a70 70 0 0 1-4-2l-3-2-1-1-1-2-1-1v-1l-1-10-1-69-30-1-46-1c-10-4-14-9-14-20v-15l4-8 1-1s-1 0 0 0l1-1 4-2 9-2h72v-79l1-2v-1l1-2 1-1 2-2 1-1 1-1 2-1h1l4-1h3l23 1a643 643 0 0 1 6 5v1l3 12v72h71l12 3 2 1 1 1 1 1 1 2 1 2v31l-1 2-1 1a371 371 0 0 0-6 5h-3l-73 1-5 1Z",
    "data-index": 224,
    style: {
      opacity: 1
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F9275",
    d: "m683 658 1 79h-72l-9 2c2-5 6-5 10-5h62c5 0 7 0 6-6v-13l1-49 1-8Z",
    "data-index": 225
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F9275",
    d: "m816 739-12-2h-71v-72l-3-12c6 3 5 9 5 14v61c0 5 1 7 6 7h63c4 0 8 2 12 4Z",
    "data-index": 226
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F9275",
    d: "m683 788 1 69 1 10c-1-3-3-6-3-10a2607 2607 0 0 1 1-69Z",
    "data-index": 227
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#377750",
    d: "m734 788 4-1 72-1-5 2h-71Z",
    "data-index": 228
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#377750",
    d: "M683 788h-70l-6-1h46l30 1Z",
    "data-index": 229
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "m823 777-1-30c1 3 3 5 3 8l-1 20-1 2Z",
    "data-index": 230
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M724 647a479 479 0 0 1-23-2c8-1 15-2 23 2Z",
    "data-index": 231
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F9275",
    d: "M596 743c0 3-1 5-3 8-2-4 0-6 3-8Z",
    "data-index": 232
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M814 786c1-1 1-2 3-2l-3 2Z",
    "data-index": 235
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M733 865v-5 5Z",
    "data-index": 236
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M822 779v-1 1Z",
    "data-index": 240
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F9275",
    d: "M730 652h-1 1Z",
    "data-index": 246
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F9275",
    d: "M598 741v1-1Z",
    "data-index": 249
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F9275",
    d: "M597 742v1-1Z",
    "data-index": 251
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8768",
    d: "M896 749Z",
    "data-index": 253
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6AEAB",
    d: "M264 323Z",
    "data-index": 259
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6AEAB",
    d: "M349 650h-86l4-1a28908 28908 0 0 1 82 1Z",
    "data-index": 260
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAddTransparentSmall);
export default __webpack_public_path__ + "static/media/document-add-transparent_small.bb96a2fc264de086fbe5c212da0c8b8c.svg";
export { ForwardRef as ReactComponent };